import { onMounted, watch, ref, computed, onUpdated } from "vue"
import { useStore } from "vuex"
import onTransitionendCallback from 'components/PageOverlay/methods/onTransitionendCallback'

export default {
    name: "OpretHoldOverlay",
    props: {
        createHoldUrl: {
            type: String,
            required: false
        }
    },
    setup(props){
        const store = useStore()
        const gtmActive = !!window?.dataLayer?.find(
            (element) => element['gtm.start']
        ) // check if gtm is active

        const createHoldUrl = computed(() => props.createHoldUrl ?? store.state.main.page_overlay_content_data.createHoldUrl)
        const reactivateHoldUrl = computed(() => `${createHoldUrl.value}?previous-holdkode=${selectedPreviousTeam.value}`)

        const selectedPreviousTeam = ref(null)

        const previousTeams = computed(()=> {
            const teamlist = store.state.stafet.previousTeams
            return (Array.isArray(teamlist)) 
                ? teamlist
                : null
        })

        const showSpinner = computed(()=>previousTeams.value === null)

        let first,
            last,
            close
            

        const tabTrap = function (e) {
            if (e.shiftKey && e.target.dataset.order === 'first') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && e.target.dataset.order === 'last') {
                e.preventDefault()
                close.focus()
            }

            if (!e.shiftKey && !e.target.dataset.order) {
                e.preventDefault()
                first.focus()
            }
        }

        const handleCreateTeam = function(){
            location.href = createHoldUrl.value
        }

        const handleReactivateTeam = function(){
            location.href = reactivateHoldUrl.value
        }

        onMounted(() => {
            store.dispatch('stafet/getPreviousTeams')
            first = document.querySelector(
                '[data-order="first"]'
            )
            last = document.querySelector(
                '[data-order="last"]'
            )
            close = document.querySelector('.kb-page-overlay__close')
            onTransitionendCallback(
                {
                    opening() {
                        if(first){
                            first.focus()
                        } else {
                            close.focus()
                        }
                        
                    }
                },
                { persistent: true }
            )
        })

        onUpdated(()=>{
            first = document.querySelector(
                '[data-order="first"]'
            )
            last = document.querySelector(
                '[data-order="last"]'
            )

            selectedPreviousTeam.value = !selectedPreviousTeam.value 
                ? selectedPreviousTeam.value = previousTeams.value[0].id
                : selectedPreviousTeam.value
        })

        return {
            handleCreateTeam,
            handleReactivateTeam,
            tabTrap,
            previousTeams,
            showSpinner,
            selectedPreviousTeam,
            getLabel: (labelKey) =>
                store.getters['labels/getLabel']({
                    labelCollection: 'OpretHoldOverlay',
                    labelKey
                })
        }
    }
}